import { StockViewKey, StockView } from '@shared/entity';

export const CONSUMPTION_FILTER_BUTTONS_CONFIG: Record<
  StockViewKey,
  { defaultMessage: string; id: string }
> = {
  [StockView.byUser]: {
    defaultMessage: 'Podle lidí',
    id: 'consumption.stockViewKey.byUser',
  },
  [StockView.byProduct]: {
    id: 'consumption.stockViewKey.byProducts',
    defaultMessage: 'Podle produktů',
  },
  [StockView.allRecords]: {
    defaultMessage: 'Historie záznamů',
    id: 'consumption.stockViewKey.allRecords',
  },
};
